import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-survey-custom-fields-filter',
  templateUrl: './survey-custom-fields-filter.component.html',
  styleUrls: ['./survey-custom-fields-filter.component.scss'],
  standalone: false
})
export class SurveyCustomFieldsFilterComponent implements OnInit, OnChanges {
  @Input() teamMemberCustomFields: any[] = [];
  @Input() members: any[] = [];
  @Input() filters: any = { custom: {} };

  @Output() filterChange = new EventEmitter<void>();

  ngOnInit(): void {
    this.initializeFilters();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['teamMemberCustomFields']) {
      this.initializeFilters();
    }
  }

  initializeFilters(): void {
    if (!this.filters.custom) {
      this.filters.custom = {};
    }
    (this.teamMemberCustomFields || []).forEach(f => {
      if (this.filters.custom[f.id] === undefined) {
        if (f.type === 'number' || f.type === 'date') {
          this.filters.custom[f.id] = { min: null, max: null };
        } else if (f.type === 'text') {
          this.filters.custom[f.id] = [];
        } else {
          this.filters.custom[f.id] = 'ALL';
        }
      }
    });
  }

  getUniqueCustomValues(field: any): string[] {
    const values = (this.members || []).map(m => (m as any).customs?.team_member_custom_fields?.[field.id])
      .filter(v => v !== undefined && v !== null && v !== '');
    return Array.from(new Set(values)).sort();
  }

  onFilterChange(): void {
    this.filterChange.emit();
  }
}
